module.exports = __webpack_public_path__ + "static/media/round_diamond.b3472907.jpeg";